import i18n from '@dms/i18n';

import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function ServiceBookSubSection() {
  return (
    <VFKit.SubSection
      data-testid="service-book-section"
      useCard
      title={i18n.t('entity.vehicle.labels.serviceBook')}
    >
      <VFKit.Group data-testid="service-book-type" columns={[1, 2]}>
        <VFKit.ServiceBookTypeChips />
        <VFKit.ShowWhen
          name="serviceBookType"
          condition={(serviceBookType) => serviceBookType?.at(0) !== 'SERVICEBOOKTYPE_NONE'}
        >
          <VFKit.ServiceBookStateChips />
        </VFKit.ShowWhen>
      </VFKit.Group>
    </VFKit.SubSection>
  );
}
